/**
 * Centralized query key factory for TanStack Query
 * Ensures consistent query key patterns and easy invalidation
 */

export const queryKeys = {
  // Dashboard queries
  dashboard: {
    all: ['dashboard'] as const,
    metrics: (companyId: string | null) => ['dashboard', 'metrics', companyId] as const,
    alerts: (companyId: string | null) => ['dashboard', 'alerts', companyId] as const,
    onboardingMetrics: (companyId: string | null) => ['dashboard', 'onboardingMetrics', companyId] as const,
    onboardingTasks: (companyId: string | null) => ['dashboard', 'onboardingTasks', companyId] as const,
    billingReadiness: (companyId: string | null) => ['dashboard', 'billingReadiness', companyId] as const,
  },
  
  // Notification queries
  notifications: {
    all: ['notifications'] as const,
    list: (userId: string | null) => ['notifications', 'list', userId] as const,
    unreadCount: (userId: string | null) => ['notifications', 'unreadCount', userId] as const,
  },

  // Company queries
  company: {
    all: ['company'] as const,
    current: () => ['company', 'current'] as const,
    users: (companyId: string | null) => ['company', 'users', companyId] as const,
    user: (companyId: string | null, userId: string | null) => 
      ['company', 'users', companyId, userId] as const,
  },

  // Billing queries
  billing: {
    all: ['billing'] as const,
    settings: (companyId: string | null) => ['billing', 'settings', companyId] as const,
    stripeConnect: (companyId: string | null) => ['billing', 'stripeConnect', companyId] as const,
    // TODO: Financial Reports - Feature not yet implemented
    // Currently no financial data flows through the application
    // Uncomment when feature is ready:
    // financialReports: (companyId: string | null) =>
    //   ['billing', 'financialReports', companyId] as const,
  },

  // Waiver queries
  waivers: {
    all: ['waivers'] as const,
    templates: (companyId: string | null) => ['waivers', 'templates', companyId] as const,
    template: (templateId: string | null) => ['waivers', 'template', templateId] as const,
    active: (companyId: string | null, requiresChild?: boolean) => 
      ['waivers', 'active', companyId, requiresChild] as const,
    signed: (userId: string | null, childProfileId: string | null, companyId: string | null) =>
      ['waivers', 'signed', userId, childProfileId, companyId] as const,
    requirement: (userId: string | null, companyId: string | null, childProfileId?: string | null) =>
      ['waivers', 'requirement', userId, companyId, childProfileId] as const,
    signedUrl: (signatureId: string | null) => ['waivers', 'signedUrl', signatureId] as const,
  },
} as const;

